<template>
  <div>
    <h1>Little Bobby</h1>

    <div
      v-for="(example, index) in examples"
      :key="index"
      class="p-lg mb-xxl bg-whiteOverride rounded-sm"
    >
      <h2>{{ example.header }}</h2>
      <DataTable
        :columns="example.columns"
        :rows="example.rows"
      />
    </div>
  </div>
</template>

<script>
// @ts-check
import { h } from 'vue';

import createImportedData from '@/store/modules/bulkSend/factories/importedData';

import FontIcon from '@/components/Icon.vue';
import DataTable from '@/components/library/dataTables/DataTable.vue';

export default {
  components: { DataTable },
  setup() {
    const examples = [
      {
        header: 'Default',
        columns: [
          { heading: 'Row' },
          {
            heading: 'Envelope Title',
          },
          'Signer 1 Name',
          'Signer 1 Email',
          'Signer 2 Name',
          'Signer 2 Email',
          'Signer 1 Test Merge Field',
        ],
        rows: createImportedData(4, [
          'Row',
          'Envelope Title',
          'Signer 1 Name',
          'Signer 1 Email',
          'Signer 2 Name',
          'Signer 2 Email',
          'Signer 1 Test Merge Field',
        ]),
      },
      {
        header: 'Errors',
        columns: [
          {
            heading: '',
            render: () =>
              h(
                'div',
                {
                  class:
                    'flex items-center justify-center h-full pl-4 pr-8 border-solid border-0 border-l-error border-l-8',
                },
                [
                  h(FontIcon, {
                    props: { name: 'exclamation' },
                    class:
                      'text-white bg-error rounded-full h-base w-base p-xs',
                  }),
                ],
              ),
            class: 'h-full p-0',
          },
          'Row',
          'Reason',
          'Envelope Title',
          'Signer 1 Name',
          'Signer 1 Email',
          'Signer 2 Name',
          'Signer 2 Email',
          'Signer 1 Test Merge Field',
          'Signer 2 Test Merge Field',
        ],
        rows: createImportedData(
          4,
          [
            '',
            'Row',
            'Reason',
            'Envelope Title',
            'Signer 1 Name',
            'Signer 1 Email',
            'Signer 2 Name',
            'Signer 2 Email',
            'Signer 1 Test Merge Field',
            'Signer 2 Test Merge Field',
          ],
          [
            ['', 12, {}],
            [
              '',
              128,
              {
                'Signer 1 Name': ['The title field is required.'],
                'Signer 2 Email': ['The email field is required.'],
              },
            ],
            ['', 300, {}],
            ['', 1485, {}],
          ],
        ),
      },
      {
        header: 'Copies',
        columns: [
          'Row',
          'Envelope Title',
          'Signer 1 Name',
          'Signer 1 Email',
          'Signer 1 Test Merge Field',
          'Copy 1 Name',
          'Copy 1 Email',
        ],
        rows: createImportedData(4, [
          'Row',
          'Envelope Title',
          'Signer 1 Name',
          'Signer 1 Email',
          'Signer 1 Test Merge Field',
          'Copy 1 Name',
          'Copy 1 Email',
        ]),
      },
    ];

    return {
      examples,
    };
  },
};
</script>

<style>
.aspect-square {
  aspect-ratio: 1 / 1;
}
</style>
